module.exports = __webpack_public_path__ + "img/application6.8649cb7b.png";